module.exports = {
  homePage: {
    section0: '嘉黍工程管理咨询有限公司',
    section1: '设计管理<br/>项目管理<br/>项目控制<br/>项目整体统筹管理',
    section2: '工料测量与分析 <br/>采购管理<br/>价值工程分析<br/>技术尽职调查',
    section3: '项目可行性调研<br/>选址与土地交易<br/>政府报建<br/>项目中途介入会诊并解决方案',
    section4: 'BIM 及BIM⁺服务 (3D/4D/5D/6D等)<br/>BIM应用策略<br/>BIM 项目管理<br/>BIM 培训',
    section5: '设计管理<br/>项目管理<br/>项目控制<br/>项目整体管理',
    section6: '关于我们',
    section7: '服务范围',
    section8: '项目案例',
    section9: '联系我们',
    sloganTitle: '“百工居肆以成其事，君子学以致其道” ',
    sloganContent: '嘉黍工程管理咨询有限公司是一家由工程项目管理行业精英组建的致力于为客户提供国际经典工程项目管理服务的企业。嘉黍管理的核心成员均为多年在超大型国企和外企或境外从事工程项目建设并具有丰富管理经验的行业专家，其项目经验涵盖了各种类型的建筑工程'
  },
  about: {
    title: '关于我们',
    content0: '嘉黍工程管理咨询有限公司是一家由工程项目管理行业精英组建的致力于为客户提供国际经典工程项目管理服务的企业。嘉黍管理的核心成员均为多年在超大型国企和外企或境外从事工程项目建设并具有丰富管理经验的行业专家，其项目经验涵盖了各种类型的建筑工程。',
    content1: '除了精于全过程项目开发与建设管理服务，嘉黍管理同时拥有坚实的诸如BIM和BIM⁺的数字化技术平台和团队资源，并专注于为客户在规划、设计、施工、及设备设施运营维护等各个实施阶段订制数字信息化的项目专项技术管理服务。'
  },
  service: {
    title: '服务范围',
    t0: '(管理咨询服务)',
    t1: '(设计管理)',
    t2: '(项目控制)',
    t3: '(工料测量与分析)',
    t4: '(价值工程分析)',
    t5: '(技术尽职调查)',
    t6: '(项目选址与土地征购)',
    t7: '(政府报建)',
    t8: '(项目中途介入会诊并解决方案)',
    t9: '(BIM & BIM⁺ 技术服务)'
  },
  project: {
    title: '项目案例'
  },
  contact: {
    title: '联系我们',
    content0: 'INFO@DIGIPROS-PM.COM, DIGITALPROJECTS@DIGIPROS-PM.COM<br/>中国上海市茶陵北路20号X2创意空间5幢1F'
  },
  footer: {
    name: '© 2016 - 2018 BY DIGITAL PROJECTS<br/>© 2016 - 2018 BY嘉黍工程管理咨询有限公司',
    contact: 'DIGITAL PROJECTS中国上海市茶陵北路20号X2创意空间5幢1F<br/>CONTACT: INFO@DIGIPROS-PM.COM, DIGITALPROJECTS@DIGIPROS-PM.COM '
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js